"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var captcha_service_1 = require("./captcha.service");
var ReCaptchaComponent = (function () {
    function ReCaptchaComponent(_zone, _captchaService) {
        this._zone = _zone;
        this._captchaService = _captchaService;
        this.site_key = null;
        this.theme = 'light';
        this.type = 'image';
        this.size = 'normal';
        this.tabindex = 0;
        this.badge = 'bottomright';
        /* Available languages: https://developers.google.com/recaptcha/docs/language */
        this.language = null;
        this.captchaResponse = new core_1.EventEmitter();
        this.captchaExpired = new core_1.EventEmitter();
        this.widgetId = null;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    ReCaptchaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._captchaService.getReady(this.language)
            .subscribe(function (ready) {
            if (!ready)
                return;
            // noinspection TypeScriptUnresolvedVariable,TypeScriptUnresolvedFunction
            _this.widgetId = window.grecaptcha.render(_this.targetRef.nativeElement, {
                'sitekey': _this.site_key,
                'badge': _this.badge,
                'theme': _this.theme,
                'type': _this.type,
                'size': _this.size,
                'tabindex': _this.tabindex,
                'callback': (function (response) { return _this._zone.run(_this.recaptchaCallback.bind(_this, response)); }),
                'expired-callback': (function () { return _this._zone.run(_this.recaptchaExpiredCallback.bind(_this)); })
            });
        });
    };
    // noinspection JSUnusedGlobalSymbols
    ReCaptchaComponent.prototype.reset = function () {
        if (this.widgetId === null)
            return;
        // noinspection TypeScriptUnresolvedVariable
        window.grecaptcha.reset(this.widgetId);
        this.onChange(null);
    };
    // noinspection JSUnusedGlobalSymbols
    ReCaptchaComponent.prototype.execute = function () {
        if (this.widgetId === null)
            return;
        // noinspection TypeScriptUnresolvedVariable
        window.grecaptcha.execute(this.widgetId);
    };
    ReCaptchaComponent.prototype.getResponse = function () {
        if (this.widgetId === null)
            return null;
        // noinspection TypeScriptUnresolvedVariable
        return window.grecaptcha.getResponse(this.widgetId);
    };
    ReCaptchaComponent.prototype.writeValue = function (newValue) {
        /* ignore it */
    };
    ReCaptchaComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ReCaptchaComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    ReCaptchaComponent.prototype.recaptchaCallback = function (response) {
        this.onChange(response);
        this.onTouched();
        this.captchaResponse.emit(response);
    };
    ReCaptchaComponent.prototype.recaptchaExpiredCallback = function () {
        this.onChange(null);
        this.onTouched();
        this.captchaExpired.emit();
    };
    return ReCaptchaComponent;
}());
ReCaptchaComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 're-captcha',
                template: '<div #target></div>',
                providers: [
                    {
                        provide: forms_1.NG_VALUE_ACCESSOR,
                        useExisting: core_1.forwardRef(function () { return ReCaptchaComponent; }),
                        multi: true
                    }
                ]
            },] },
];
/** @nocollapse */
ReCaptchaComponent.ctorParameters = function () { return [
    { type: core_1.NgZone, },
    { type: captcha_service_1.ReCaptchaService, },
]; };
ReCaptchaComponent.propDecorators = {
    'site_key': [{ type: core_1.Input },],
    'theme': [{ type: core_1.Input },],
    'type': [{ type: core_1.Input },],
    'size': [{ type: core_1.Input },],
    'tabindex': [{ type: core_1.Input },],
    'badge': [{ type: core_1.Input },],
    'language': [{ type: core_1.Input },],
    'captchaResponse': [{ type: core_1.Output },],
    'captchaExpired': [{ type: core_1.Output },],
    'targetRef': [{ type: core_1.ViewChild, args: ['target',] },],
};
exports.ReCaptchaComponent = ReCaptchaComponent;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/~/angular2-recaptcha/lib/captcha.component.js
// module id = ../../../../angular2-recaptcha/lib/captcha.component.js
// module chunks = 3